<template>
  <a-modal
    :title="$t('synchronization.delete_warning')"
    :visible="isOpened"
    :ok-text="$t('common.delete')"
    :ok-button-props="{
      props: {
        type: 'danger',
        loading: deleteRequest,
        disabled: !deleteConfirmationValueIsValid
      }
    }"
    @ok="handleDeleteSync"
    @cancel="$emit('close')"
  >
    <div class="popover-body__input">
      <a-input
        v-model="deleteConfirmationValue"
        :placeholder="$t('common.enter_text')"
      />
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue"

import i18n from "@/i18n"
import { useSyncListStore } from "@/modules/sync/store/useSyncListStore"
import { useSyncStore } from "@/modules/sync/store/useSyncStore"

// Helper Types/Variables
type Props = {
  isOpened: boolean
  syncUuid: string
}

const props = defineProps<Props>()
const emit = defineEmits(["close", "delete"])
// End Helper Types/Variables

// Store & Route
const syncStore = useSyncStore()
const syncListStore = useSyncListStore()
// End Store & Route

// State
const deleteConfirmationKey = ref(i18n.t("synchronization.delete_key"))
const deleteConfirmationValue = ref("")
const deleteRequest = ref(false)
// End State

// Computed
const deleteConfirmationValueIsValid = computed(() => {
  return deleteConfirmationValue.value.trim() === deleteConfirmationKey.value
})
// End Computed

// Methods
const handleDeleteSync = () => {
  deleteRequest.value = true
  syncStore
    .deleteSynchronization(props.syncUuid)
    .then(() => {
      syncListStore.getSynchronizations()
      emit("close")
      emit("delete")
    })
    .catch((e: any) => {
      console.error(e)
    })
    .finally(() => {
      deleteRequest.value = false
    })
}
// End Methods
</script>
